(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[245],{

/***/ 68122:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feedbacks",
      function () {
        return __webpack_require__(4858);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ feedbacks; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/layout/Layout.tsx + 13 modules
var Layout = __webpack_require__(78690);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/feedbacks/FeedbackItem/FeedbackItem.tsx





var FeedbackItem = function(param) {
    var _feedback = param.feedback, _image = _feedback.image, height = _image.height, width = _image.width, url = _image.url;
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: classes.item,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: url,
            width: width,
            height: height,
            quality: 75
        })
    });
};
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        item: (0,_define_property/* default */.Z)({
            display: "inline-block",
            width: "100%",
            position: "relative",
            transition: "200ms ease-in",
            paddingTop: theme.spacing(2),
            "&:hover": {
                zIndex: 1,
                transform: "scale(1.3)"
            }
        }, theme.breakpoints.up("sm"), {
            paddingTop: theme.spacing(4),
            "&:hover": {
                zIndex: 1,
                transform: "scale(1.2)"
            }
        })
    };
});
/* harmony default export */ var FeedbackItem_FeedbackItem = (FeedbackItem);

;// CONCATENATED MODULE: ./components/feedbacks/Feedbacks.tsx





var Feedbacks = function(param) {
    var feedbacks = param.feedbacks;
    var classes = Feedbacks_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: classes.container,
        component: "section",
        children: feedbacks.map(function(feedback) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackItem_FeedbackItem, {
                feedback: feedback
            }, feedback.sys.id);
        })
    });
};
var Feedbacks_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return {
        container: (_obj = {
            columnGap: theme.spacing(2),
            columnCount: 2,
            paddingBottom: theme.spacing(2),
            fontSize: 0
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
            columnCount: 3,
            columnGap: theme.spacing(4)
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            columnCount: 4
        }), _obj)
    };
});
/* harmony default export */ var feedbacks_Feedbacks = (Feedbacks);

;// CONCATENATED MODULE: ./pages/feedbacks.tsx






var FeedbacksPage = function(param) {
    var pageMeta = param.pageMeta, feedbacks = param.feedbacks;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        pageMeta: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageMeta), {
            title: "Відгуки"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(feedbacks_Feedbacks, {
            feedbacks: feedbacks
        })
    });
};
var __N_SSG = true;
/* harmony default export */ var feedbacks = (FeedbacksPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [112,351,690,774,888,179], function() { return __webpack_exec__(68122); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);